<!-- 发布资讯 -->
<template>
    <div class="form-group-style">
      <h1 class="title">新增资讯</h1>
      <div class="formLine"></div>
      <el-row type="flex" justify="center" class="news-container">
        <el-col :span="16">
          <el-form label-position="top" :model="info" :rules="infoRules" ref="userInfoForm">
            <el-form-item prop="title">
              <el-input placeholder="请输入资讯标题" class="input-control" v-model="info.title"></el-input>
              <span v-if="titleWords" class="word_error">{{titleWords}}</span>
            </el-form-item>
            <el-form-item label="文章关键字" prop="keywords">
              <el-tag :key="tag" v-model="newsTags" v-for="tag in newsTags" closable :disable-transitions="false"
                @close="handleClose(tag)">{{ tag }}</el-tag>
              <template v-if="newsTags.length < 4">
                <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small"
                  @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm"></el-input>
                <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 添加关键字</el-button>
              </template>
            </el-form-item>
            <el-form-item label="文章来源" prop="source">
                <el-input placeholder="请输入文章来源，必填" class="input-control" v-model="info.source"></el-input>
                <span v-if="sourceWords" class="word_error">{{sourceWords}}</span>
            </el-form-item>
            <el-form-item label=" " prop="content">
              <UE :options="eidtorOptions" defaultMsg="" ref="ue" />
              <span v-if="contentWords" class="word_error">{{contentWords}}</span>
            </el-form-item>
            <div class="picture-deal-group">
              <label class="deal-label">图片处理：</label>
              <el-button @click="cropPicture" size="mini" type="primary">裁剪图片</el-button>
              <span class="deal-desc">可将文章中的大图（长*宽大于520*350px的图片），自动裁剪为520*350px的尺寸的图片。</span>
            </div>
  
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="封面和描述" prop="picture">
                  <div class="huxing-input">
                    <div class="upload-group clearfix" v-if="info.full_thumb && info.full_thumb !== ''">
                      <div class="upload-item">
                        <img :src="info.full_thumb" alt />
                        <div class="shadow">
                          <i class="el-icon-delete" @click="clearUpload"></i>
                        </div>
                      </div>
                    </div>
                    <div class="upload-group-2" v-else>
                      <i class="el-icon-plus"></i>
                      <input type="file" class="type-file" accept="*" @change="checkFile($event)"
                        id="pictureUploadFile" />
                    </div>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="18">
                <el-form-item label="1" prop="description" class="none-label">
                  <el-input placeholder="选填，不填则自动选取文章的前240字，文章描述可帮助读者快速了解内容，将显示在文章列表页和分享页主体内容" type="textarea"
                    class="input-control" v-model="info.description"></el-input>
                  <span v-if="desWords" class="word_error">{{desWords}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="form-button ">
              <span class="save-time" v-if="saveTime">({{ saveTime }} 已自动保存)</span>
              <span v-else style="margin-right:5px;white-space: nowrap;">(完善必填字段后，即可自动保存)</span>
              <el-button type="primary" :loading="isClick" @click="submitForm('userInfoForm', '1')">保存至草稿箱</el-button>
              <el-button type="primary" :loading="isClick" @click="submitForm('userInfoForm', '2')">保存并发布</el-button>
              <el-button @click="goBack">返回</el-button>
            </div>
          </el-form>
        </el-col>
      </el-row>
      <el-dialog
          title="违禁词提示"
          :visible.sync="wordsDialog"
          width="40%"
          :before-close="(done)=>{done()}">
          <div style="margin-bottom:10px;line-height: 20px;" v-if="findWords.type_common.length > 0">存在通用违禁词：<span style="color:red">{{findWords.type_common.join(',')}}</span></div>
          <div style="margin-bottom:10px;line-height: 20px;" v-if="findWords.type_risk.length > 0">存在风险违禁词：<span style="color:red">{{findWords.type_risk.join(',')}}</span></div>
          <div style="margin-bottom:10px;line-height: 20px;" v-if="findWords.type_high_risk.length > 0">存在高危违禁词：<span style="color:red">{{findWords.type_high_risk.join(',')}}</span></div>
          <div style="margin-bottom:10px;line-height: 20px;" v-if="findWords.type_author.length > 0">存在来源屏蔽词：<span style="color:red">{{findWords.type_author.join(',')}}</span></div>
          <div style="margin-bottom:10px;" v-if="findWords.type_risk.length > 0 && !findWords.type_high_risk.length > 0 && !findWords.type_common.length > 0 && !findWords.type_author.length > 0">风险违禁词在一定语义下可能会存在风险！</div>
          <div>请检查并修改后再进行保存！恶意填写违禁词，情节严重将进行账号冻结并追究责任。</div>
          <span slot="footer" class="dialog-footer">
              <template v-if="findWords.type_risk.length > 0 && !findWords.type_high_risk.length > 0 && !findWords.type_common.length > 0 && !findWords.type_author.length > 0">
                  <el-button type="primary" @click="cancelSave">暂不保存</el-button>
                  <el-button type="primary" @click="continueSave">继续保存</el-button>
              </template>
              <template v-else>
                  <el-button type="primary" @click="cancelSave">确定</el-button>
              </template>
          </span>
      </el-dialog>  
    </div>
  </template>
  <script>
  import {getFilterWords} from '@/service/customer'
  import { getNowTime } from '@/utils/index'
  import { addCommonNews,editCommonNews,deleteCommonNews} from "@/service/allNewsList";
  import { validateEmpty } from "@/utils/validate";
  import { validateNumber } from "@/utils/validate"; // editor content
  import { UPLOAD_CODE } from "@/config/index";
  import { uploadFile } from "@/service/user";

  import UE from '@/components/editoritem/uEditor';
  function  beforeunload(e){
  
    var confirmationMessage = 'Your own message goes here...';
    (e || window.event).returnValue = confirmationMessage;     
    return confirmationMessage; 
  }
  let _this;
  function validContent(rules, value, callback){
    console.log(_this.$refs.ue.getContent().count)
    if(_this.$refs.ue && _this.$refs.ue.getContent().count < 10 ||
       _this.$refs.ue && _this.$refs.ue.getContent().count > 12000){
      return  callback(new Error(`长度10到12000个字符`))
    }else{
      callback()
    }
  }
  
  export default {
    name: "PublishFloorInfo",
    components: {
      UE
    },
    data() {
      return {
        isClick:false,
        info: {
          title: "",
          source: "",
          keywords: "",
          categories_name: "",
          description: "",
          content: "",
          categories_id: "",
          full_thumb: "",
          thumb: "",
        },
        oldInfo: {},
        id: "",
        saveTime: "",
        newsTags: [],
        inputVisible: false,
        inputValue: "",
        cateName: "",
        categoryList: "",
        infoRules: {
          title: [
            { validator: validateEmpty, result: "资讯标题", trigger: "blur" },
            { min: 4, max: 50, message: "长度4到50个字符" }
          ],
          categories_id: [
            {
              required: true,
              validator: validateNumber,
              type: 1,
              min: 0,
              max: 99999,
              result: "分类",
              message: "请选择分类"
            }
          ],
          source: [
            {
              required: true,
              validator: validateEmpty,
              result: "资讯来源",
              trigger: "blur"
            },
            { min: 2, max: 15, message: "长度2到15个字符" }
          ],
          keywords: [
            { required: true, validator: validateEmpty, result: '关键词', trigger: 'change' }, { min: 1, max: 99, message: '长度1到99个字符' }
            //{ required: true, message: "请至少添加一个关键字", trigger: "change" }
          ],
          description: [
            { result: "描述", trigger: "blur" },
            { min: 10, max: 240, message: "长度10到240个字符" }
          ],
          content: [
            { validator: validateEmpty, result: "内容", trigger: "blur" },
            { validator: validContent,result:"长度"}
            // { min: 10, max: 12000, message: "长度10到12000个字符" }
          ]
        },
        isClear: false,
        checkAll: false,
        isIndeterminate: true,
        list: [],
        terminals: [], //终端
        pageAll: [],
        recommandData: [],
        centerDialogVisible: false,
        editorHouse: null,
        showError: false,
        isClose: false,
        // 编辑器配置
        eidtorOptions: {
          pictureConfig: {
            code: UPLOAD_CODE.news
          },
          videoConfig: {
            code: UPLOAD_CODE.newsVideo
          },
          uploadType: 'common',
          wordLimit: 12000,
          config: {
            items: ['source', '|', 'undo', 'redo', '|', 'justifyleft', 'justifycenter', 'justifyright', '|', 'forecolor', 'bold', 'selectall', 'removeformat', 'clearhtml', 'quickformat', '|', 'picture', 'link', 'unlink', 'video', 'table', 'fullscreen', 'addIframe'],
          }
        },
        timer:null,
        newsInfo:{},
        filterWords:{},
        findWords:{
            type_risk:[],
            type_common:[],
            type_high_risk:[],
            type_author:[]
        },
        arisenWords:[],
        wordsDialog:false,
      };
    },
    props: {
      callback: Function
    },
    computed: {
      titleWords(){
          let words = []
          if(this.arisenWords && this.arisenWords.length>0){
              this.arisenWords.forEach((item)=>{
                  if(this.info.title && this.info.title.indexOf(item) != -1){
                      words.push(item)
                  }
              })
          }
          return words.length > 0 ? words.join(',') : null
      },
      sourceWords(){
        let words = []
        if(this.arisenWords && this.arisenWords.length>0){
            this.arisenWords.forEach((item)=>{
                if(this.info.source && this.info.source.indexOf(item) != -1){
                    words.push(item)
                }
            })
        }
        return words.length > 0 ? words.join(',') : null
      },
      contentWords(){
        let words = []
        if(this.arisenWords && this.arisenWords.length>0){
            this.arisenWords.forEach((item)=>{
                if(this.info.content && this.info.content.indexOf(item) != -1){
                    words.push(item)
                }
            })
        }
        return words.length > 0 ? words.join(',') : null
      },
      desWords(){
        let words = []
        if(this.arisenWords && this.arisenWords.length>0){
            this.arisenWords.forEach((item)=>{
                if(this.info.description && this.info.description.indexOf(item) != -1){
                    words.push(item)
                }
            })
        }
        return words.length > 0 ? words.join(',') : null
      }
    },
    created(){
      _this = this
        getFilterWords().then(res => {
            this.filterWords = res
        })
    },
    mounted() {
      this.initData();
      window.addEventListener("beforeunload",beforeunload,false)
  
      this.timer = setInterval(() => {
        this.saveToDraft();
      }, 60000)
  
    },
    beforeRouteLeave(to, from, next) {
      clearInterval(this.timer)
      window.removeEventListener("beforeunload",beforeunload,false)
      if (!this.isClose) {
        this.saveToDraft();
        const answer = window.confirm('存在未保存的内容，是否确认关闭网页')
        if (answer) {
          next()
        }
      } else {
        next()
      }
      return false;
    },
    watch: {
      list() {
        this.info.hasChecked = this.list.length <= 0 ? "" : "hasChecked";
      },
    },
    methods: {
      cropPicture() {
        this.$refs.ue.cropPicture();
  
      },
      //关键字
      handleClose(tag) {
        this.newsTags.splice(this.newsTags.indexOf(tag), 1);
      },
      showInput() {
        this.inputVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },
      handleInputConfirm() {
        let inputValue = this.inputValue;
        if (inputValue) {
          this.newsTags.push(inputValue);
  
        }
        this.inputVisible = false;
        this.inputValue = "";
      },
      submitForm(formName, type) { //保存并发布
        let checkedHid = []; //选中楼盘
        let checkedRec = []; //选中推荐位
        if (this.list.length && this.list.length > 6) {
          this.$message({
            type: "warning",
            message: "选中楼盘数量最大为6个"
          });
          return false;
        } else {
          for (let i in this.list) {
            checkedHid.push(this.list[i].id);
          }
        }
        for (let a in this.recommandData) {
          if (this.recommandData[a].checkedItems.length > 0) {
            this.recommandData[a].checkedItems.filter(item => {
              checkedRec.push(item.id);
            });
          }
        }
        this.info.keywords = this.newsTags.join(",");
        this.info.content = this.$refs.ue && this.$refs.ue.getContent().html;
        this.info.title = this.info.title.trim();
        this.info.source = this.info.source.trim();
        this.info.keywords = this.info.keywords.trim();
        this.info.description = this.info.description.trim();
        let validInfo = {...this.info}
        let _imgReg = /<img[^>]+>/g
        validInfo.content = validInfo.content.replace(_imgReg, '{@img}');
        this.$refs[formName].validate(valid => {
          if (valid) {
            let query = this.info;
            query["categories_name"] = this.info.categories_name;
            query["house_id_str"] = checkedHid.join(",");
            query["position_id_str"] = checkedRec.join(",");
            query['status'] = type;
            query['save_auto'] = 0
  
            let isPass = this.validFilterWords(validInfo)
            if(type == 2 && !isPass){
              this.newsInfo = query
              this.wordsDialog = true;
            }else{
              this.addOrEdit(query,type)
            }
          }
        });
      },
      addOrEdit(query,type){
        this.isClick = true;
        if (this.id && this.id !== '') {
          editCommonNews(this.id,query).then((res) => {
            this.oldInfo = JSON.parse(JSON.stringify(query))
              if (type == 1) {
                this.$confirm("已成功保存至草稿箱！", "提示", {
                    confirmButtonText: "完成",
                    cancelButtonText: "继续编辑",
                    type: "success",
                })
                .then(() => {
                    this.isClose = true;
                    this.$router.push({name: 'draftsList' })
                })
                .catch(() => {
                    this.isClose = true;
                    this.$router.push({ name: 'editDraft', query: { id: res.id } })
                });
              } else {
                this.$message({
                  type: "success",
                  message: "编辑成功"
                });
                this.isClose = true;
                this.$router.push({name:"allNewsList"});
              }
          });
        } else {
          addCommonNews(query).then((res) => {
            this.id = res.id;
            this.oldInfo = JSON.parse(JSON.stringify(query))
            if (type == 1) {
                this.$confirm("已成功保存至草稿箱！", "提示", {
                    confirmButtonText: "完成",
                    cancelButtonText: "继续编辑",
                    type: "success",
                })
                .then(() => {
                    this.isClose = true;
                    this.$router.push({name: 'draftsList' })
                })
                .catch(() => {
                    this.isClose = true;
                    this.$router.push({ name: 'editDraft', query: { id: res.id } })
                });
            } else {
              this.$message({
                type: "success",
                message: "报存成功"
              });
              this.isClose = true;
              this.$router.push({name:"allNewsList"});
            }
          })
          .catch(err => {
            this.$message({
              type: "error",
              message: err.message
            });
          });
        }
      },
      saveToDraft() { //自动保存至草稿箱
        let checkedHid = []; //选中楼盘
        let checkedRec = []; //选中推荐位
        if (this.list.length && this.list.length > 6) {
          this.$message({
            type: "warning",
            message: "选中楼盘数量最大为6个"
          });
          return false;
        } else {
          for (let i in this.list) {
            checkedHid.push(this.list[i].id);
          }
        }
        for (let a in this.recommandData) {
          if (this.recommandData[a].checkedItems.length > 0) {
            this.recommandData[a].checkedItems.filter(item => {
              checkedRec.push(item.id);
            });
          }
        }
        this.info.keywords = this.newsTags.join(",");
        this.info.content = this.$refs.ue && this.$refs.ue.getContent().html;
        this.info.title = this.info.title.trim();
        this.info.source = this.info.source.trim();
        this.info.keywords = this.info.keywords.trim();
        this.info.description = this.info.description.trim();
        this.$refs.userInfoForm.validate(valid => {
          if (valid) {
            let query = this.info;
            query["house_id_str"] = checkedHid.join(",");
            query["position_id_str"] = checkedRec.join(",");
            query['save_auto'] = 1
            query['status'] = "1";
            if (JSON.stringify(this.oldInfo) !== JSON.stringify(query)) {
              console.log("数据有差异")
              if (this.id && this.id !== '') {
                editCommonNews(this.id,query).then((res) => {
                  this.oldInfo = JSON.parse(JSON.stringify(query))
                  this.saveTime = getNowTime()
                });
              } else {
                addCommonNews(query).then((res) => {
                  this.id = res.id;
                  this.oldInfo = JSON.parse(JSON.stringify(query))
                  this.saveTime = getNowTime()
  
                });
              }
            } else {
              console.log("数据未变更")
            }
          }
        });
      },
      // 清空上传
      clearUpload() {
        this.$set(this.info, "thumb", "");
        this.$set(this.info, "full_thumb", null);
        document.querySelector("#pictureUploadFile").value = "";
      },
      async initData() {
        this.groupData();
      },
      groupData() {
        let listData = this.positionAll;
        for (let i in listData) {
          let row = listData[i];
          let t = this.terminals.filter(item => {
            if (item.id == row.terminal_id) return item;
          });
          row.terminal_str = t.length > 0 ? t[0].name : "";
          row.nums = row.nums == 0 ? "-" : row.nums;
          let p = this.pageAll.filter(item => {
            if (item.id == row.page_id) return item;
          });
          row.page_str = p.length > 0 ? p[0].name : "";
        }
        for (let i in this.terminals) {
          this.terminals[i].list = [];
          listData.filter(item => {
            if (item.terminal_id == this.terminals[i].id) {
              this.terminals[i].list.push(item);
            }
          });
          this.recommandData.push({
            ...this.terminals[i],
            checkAll: false,
            isIndeterminate: false,
            checkedItems: []
          });
        }
      },
  
      // 文件上传
      checkFile(e) {
        const file = e.target;
        const filePath = file.value;
        if (!filePath) return false;
        // 验证格式是否匹配
        if (!/.(jpg|jpeg|png|webp)$/.test(filePath)) {
          this.$message({
            type: 'error',
            message: '请选择JPG/PNG/JPEG/WEBP格式的图片'
          })
          return false
        }
        // 验证上传文件大小
        const fileSize = file.files[0].size;
        if (fileSize / 1024 / 1024 > 2) {
          this.$message({
            type: "error",
            message: "上传的图片不能大于2M"
          });
          return false;
        }
        this.upload(file.files[0]);
      },
      // 上传封面图片
      async upload(file) {
        try {
          const formData = new FormData();
          formData.append("file", file);
          formData.append("code", UPLOAD_CODE.news);
          const res = await uploadFile(UPLOAD_CODE.news, formData);
          this.$set(this.info, "thumb", res.full_url);
          this.$set(
            this.info,
            "full_thumb",
            "https://" + res.full_url + "!watermark"
          );
        } catch (error) {
          this.$message({
            type: "error",
            message: error.message || "上传封面图片错误"
          });
        }
      },
      handleCheckedAllChange1(value, item) {
        item.checkedItems = value ? item.list : [];
        item.isIndeterminate = false;
      },
      handleCheckeditemsChange2(value, item) {
        let checkedCount = value.length;
        item.checkAll = checkedCount === item.list.length;
        item.isIndeterminate =
          checkedCount > 0 && checkedCount < item.list.length;
      },
      showAlert() {
        alert(9)
      },
      goBack() {
        this.isClose = true
        this.$confirm('返回后内容会丢失，是否确认返回', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (this.id && this.id !== '') {
            let query = {}
            deleteCommonNews(this.id, query).then(() => {
              this.$router.back()
            }).catch(err => {
              this.$message({
                type: 'error',
                message: err.message || '删除失败'
              })
            })
          }else{
              this.$router.back()
          }
        })
      },
      // 继续保存
      async continueSave(){
          this.addOrEdit(this.newsInfo,2)
          this.wordsDialog = false
      },
      // 暂不保存
      cancelSave(){
          this.arisenWords = [];
          if(this.findWords){
              for(let key in this.findWords){
                  if(this.findWords[key] && this.findWords[key].length>0){
                      this.arisenWords.push(...this.findWords[key])
                  }
              }
          }
          this.wordsDialog = false
      },
      validFilterWords(info){
          this.findWords = {
              type_risk:[],
              type_common:[],
              type_high_risk:[],
              type_author:[]
          },
          // 风险违禁词
          this.filterWords.type_risk.forEach((item,index) => {
              if(info.title.indexOf(item) != -1){
                  this.findWords.type_risk.push(item)
              }else if(info.source.indexOf(item) != -1){
                this.findWords.type_risk.push(item)
              }else if(info.content.indexOf(item) != -1){
                this.findWords.type_risk.push(item)
              }else if(info.description.indexOf(item) != -1){
                this.findWords.type_risk.push(item)
              }
              this.findWords.type_risk = Array.from(new Set(this.findWords.type_risk))
          });
          // 通用违禁词
          this.filterWords.type_common.forEach((item,index) => {
              if(info.title.indexOf(item) != -1){
                  this.findWords.type_common.push(item)
              }else if(info.source.indexOf(item) != -1){
                this.findWords.type_common.push(item)
              }else if(info.content.indexOf(item) != -1){
                  this.findWords.type_common.push(item)
              }else if(info.description.indexOf(item) != -1){
                this.findWords.type_common.push(item)
              }
              this.findWords.type_common = Array.from(new Set(this.findWords.type_common))
  
          });
          // 高危违禁词
          this.filterWords.type_high_risk.forEach((item,index) => {
              if(info.title.indexOf(item) != -1){
                  this.findWords.type_high_risk.push(item)
              }else if(info.source.indexOf(item) != -1){
                  this.findWords.type_high_risk.push(item)
              }else if(info.content.indexOf(item) != -1){
                  this.findWords.type_high_risk.push(item)
              }else if(info.description.indexOf(item) != -1){
                this.findWords.type_high_risk.push(item)
              }
              this.findWords.type_high_risk = Array.from(new Set(this.findWords.type_high_risk))
  
          });
          // 来源违禁词
          this.filterWords.type_author.forEach((item,index) => {
              if(info.source.indexOf(item) != -1){
                  this.findWords.type_author.push(item)
              }
              this.findWords.type_author = Array.from(new Set(this.findWords.type_author))
  
          });
          if(this.findWords.type_risk.length > 0 
            || this.findWords.type_common.length > 0 
            || this.findWords.type_high_risk.length > 0
            || this.findWords.type_author.length > 0){
              return false
          }else{
              return true
          }
      },
    }
  };
  </script>
  
  <style lang="less">
  .picture-deal-group {
    display: -webkit-box;
    line-height: 32px;
    margin-top: 20px;
  
    .deal-label {
      color: #606266;
      font-size: 14px;
      margin-right: 10px;
    }
  
    .deal-desc {
      color: #999;
      font-size: 13px;
      margin-left: 10px;
    }
  }
  
  .el-form--label-top .el-form-item__label {
    padding: 10px 0 0;
  }
  
  .news-container {
    background-color: #fff;
    padding: 50px;
  }
  
  .form-group-style .form-container .form-item .form-label {
    width: 15%;
  }
  
  .form-group-style .form-container .form-input-item {
    width: 40%;
  }
  
  .form-group-style .form-container .form-input-item.editor {
    width: 80%;
  }
  
  .huxing-input {
    display: -webkit-box;
    height: 40px;
  
    .el-form-item {
      -webkit-box-flex: 1;
    }
  
    .labels {
      font-size: 13px;
      color: #666;
      padding: 0 8px;
      display: block;
    }
  
    .flex-all {
      -webkit-box-flex: 1;
    }
  }
  
  .checked-labels {
    border: 1px solid #e4e7ed;
    font-size: 13px;
    color: #666;
    padding: 0px 16px;
    border-radius: 3px;
    margin: 0 15px 15px 0;
    display: inline-block;
    position: relative;
    cursor: pointer;
  
    .shadow {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.6);
      cursor: pointer;
      transition: all 0.1s linear;
      opacity: 0;
  
      .el-icon-delete {
        color: #fff;
        font-size: 18px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 15px;
        height: 20px;
        display: block;
      }
    }
  
    &:hover {
      .shadow {
        opacity: 1;
      }
    }
  }
  
  .upload-group-2 {
    position: relative;
    width: 150px;
    height: 150px;
    border: 1px dashed #dcdfe6;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  
    .el-icon-plus {
      font-size: 30px;
      color: #999;
    }
  
    .type-file {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
    }
  }
  
  .upload-group {
    padding-left: 15%;
  
    .upload-item {
      width: 150px;
      height: 150px;
      position: relative;
      float: left;
  
      img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
      }
  
      .shadow {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        display: -webkit-box;
        -webkit-box-align: center;
        -webkit-box-pack: center;
        cursor: pointer;
        transition: all 0.1s linear;
        opacity: 0;
  
        .el-icon-delete {
          font-size: 21px;
          color: #fff;
          display: block;
        }
      }
  
      &:hover {
        .shadow {
          opacity: 1;
        }
      }
  
      .el-icon-close {
        position: absolute;
      }
    }
  }
  
  .house-door-uploadPicture {
    width: 500px !important;
  }
  
  .el-tag+.el-tag {
    margin-left: 10px;
  }
  
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
  
  .el-tag .el-icon-close {
    display: inline-block !important;
    border-radius: 50%;
    text-align: center;
    position: relative !important;
    cursor: pointer;
    font-size: 12px !important;
    height: 16px !important;
    width: 16px !important;
    line-height: 16px !important;
    vertical-align: middle;
    top: -1px !important;
    right: -5px !important;
  }
  
  .relative-icon {
    background-color: #f5f7fa;
    color: #909399;
    font-size: 17px;
    padding: 0 10px;
    height: 38px;
    line-height: 40px;
    cursor: pointer;
    border: 1px solid #dcdfe6;
    border-radius: 5px;
    margin-left: 15px;
  }
  
  .relative-group {
    border: 1px solid #dcdfe6;
    border-radius: 5px;
    background: #fff;
    -webkit-box-flex: 1;
  
    .relative-empty {
      color: #999;
      font-size: 12px;
      line-height: 40px;
      padding: 0 15px;
    }
  
    .relative-item {
      padding: 0px 20px;
      border-bottom: 1px solid #dcdfe6;
    }
  
    .border-none {
      border: 0;
    }
  
    .position-remove {
      color: #000;
      font-size: 13px;
      text-decoration: underline;
      cursor: pointer;
      float: right;
    }
  }
  
  .recommand-group {
    display: -webkit-box;
  
    .el-form-item {
      -webkit-box-flex: 1;
    }
  }
  
  .upload-group {
    padding-left: 0;
  }
  
  .none-label .el-form-item__label {
    color: #fff;
  }
  
  .none-label .el-form-item__label:before {
    color: #fff !important;
  }
  
  .hosueDia span.label {
    float: left;
    display: inline-block;
    font-size: 16px;
    line-height: 40px;
    margin-right: 10px;
  }
  
  .hosueDia .el-autocomplete {
    width: 80% !important;
    float: left;
  }
  
  .hosueDia .house-ipt {
    width: 100%;
    height: 40px;
  }
  
  .hosueDia .error-tip {
    margin-top: 10px;
    padding-left: 100px;
    color: red;
  }
  
  .tuij {
    float: left;
    margin-right: 20px !important;
  }
  
  .form-input-item .el-tag .el-icon-close {
    display: inline-block !important;
    border-radius: 50%;
    text-align: center;
    position: relative !important;
    cursor: pointer;
    font-size: 12px !important;
    height: 16px !important;
    width: 16px !important;
    line-height: 16px !important;
    vertical-align: middle;
    top: -1px !important;
    right: -5px !important;
  }
  
  .save-time {
    margin-right: 5px;
    font-size: 12px;
    white-space: nowrap;
  }
  .word_error{
      position: relative;
      top:-10px;
      color:red;
  }
  </style>
<style scoped>
.form-group-style .form-button{
    padding-left: 0;
}
</style>